<template>

    <div class="wrapper-main">

        <header-band
                :title="$t('magic_request_email_web_header')"
                :blueCleanfox="true"
                :back="true"
                @eventBack="back"
        ></header-band>

        <div class="page-container">

            <!--<template v-if="step === 1">-->

                <div v-show="step === 1" class="bloc-white bloc-white-separato">

                    <div class="bloc-white-child">

                        <h1 class="mlp-title">{{ $t('magic_request_email_title') }}</h1>

                        <p class="mlp-subtitle">{{ $t('magic_request_email_subtitle') }}</p>

                        <input-text class="mlp-input"
                                    ref="inputEmail"
                                    :data="loginEmail"
                                    :big="true"
                                    :placeholder="$t('magic_request_email_placeholder')"
                                    :boolFocus="startFocus"
                                    :type="'email'"
                                    :errorMessage="$t('login_error_invalid_email_password')"
                                    :error="isErrorEmail"
                                    @change="change"
                                    @pressEnter="inputSendEmail"
                        ></input-text>

                        <button class="btn btn-blue btn-big btn-mlp"
                                :class="{ 'btn-disable': !isValidEmail }"
                                @click="inputSendEmail"
                    >
                            <span v-if="state !== 'loading'">{{ $t('magic_request_email_cta') }}</span>

                            <div v-else>

                                <lottie-loader :size="24"/>

                            </div>

                        </button>

                    </div>

                    <div class="bloc-white-child">

                        <p class="mlp-secu">{{ $t('magic_request_email_security') }}</p>

                    </div>

                </div>

            <!--</template>-->

            <!--<template v-if="step === 2">-->

                <div v-show="step === 2" class="bloc-white">

                    <anim-airplane ref="airplane" class="airplane"></anim-airplane>

                    <p class="mlp-blue-title">{{ $t('magic_check_email_title') }}</p>
                    <p class="mlp-bold-email">{{ loginEmail }}</p>
                    <p class="mlp-text mlp-text-top">{{ $t('magic_check_email_order') }}</p>
                    <p class="mlp-text">{{ $t('magic_check_email_validity') }}</p>

                    <div class="bottom-bloc-white">

                        <p class="mlp-text mlp-text-space">{{ $t('magic_check_email_no_mail') }}</p>

                        <div v-if="state === 'loading'" class="mlp-bottom">

                            <lottie-loader :size="24"/>

                        </div>
                        <p v-else-if="state === 'emailSent'" class="mlp-bottom mlp-email-sent">{{ $t('magic_check_email_sent') }}</p>
                        <p v-else-if="state === 'trying'"    class="mlp-bottom mlp-trying">{{ $tc('magic_check_email_again', computedSeconds, { numberOfSeconds: counter}) }}</p>
                        <p v-else @click="tryAgain"          class="mlp-bottom mlp-link" >{{ $t('magic_check_email_send_again') }}</p>

                    </div>

                </div>

            <!--</template>-->

        </div>

        <toast ref="toast"></toast>

    </div>

</template>

<script>

    import Vuex from 'vuex'

    import Auth from '@/modules/auth'
    import Tag from '@/modules/tag'
    import UserFlow from '@/modules/userFlow'

    import AnimAirplane from '@/components/animation/Airplane.vue'
    import HeaderBand from '@/components/headers/HeaderBand'
    import InputText from '@/components/inputs/InputText'
    import LottieLoader from '@/components/lottie/LottieLoader'
    import Toast from '@/components/Toast'

    export default {

        name: 'magic-link-pre',

        components: { AnimAirplane, HeaderBand, InputText, LottieLoader, Toast },

        computed: {

            ...Vuex.mapGetters(['loginEmail']),

            computedSeconds: function () {

                return this.counter > 1 ? 0 : 1
            }

        },

        watch: {

            counter: function(value) {

                if (value === 0) {

                    this.state = ''
                    this.stopDecrement()
                }
            }
        },

        data() {

            return {
                step: 0,
                startFocus: true,
                isErrorEmail: false,
                regexMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                isValidEmail: false,
                counter: 30,
                intervalFunction: function () {},
                state: ''
            }

        },

        mounted() {

            this.goStep(1)

        },

        methods: {

            ...Vuex.mapActions(['setEmail']),

            goStep (step) {

                this.step = step

                switch (step) {
                    case 1:
                        UserFlow.setPage(this, 'magic_request_email')
                        break
                    case 2:
                        UserFlow.setPage(this, 'magic_check_email')
                        break
                }
            },

            testEmail () {

                const email = this.$refs.inputEmail.value
                return this.regexMail.test(email) && email.length > 0
            },

            inputSendEmail () {

                const email = this.$refs.inputEmail.value

                this.setEmail(email)

                if(this.testEmail()) {

                    this.state = 'loading'

                    this.sendEmail()

                } else {

                    this.isErrorEmail = true
                }
            },

            sendEmail (tryAgain) {

                this.$refs.airplane.launch()

                Auth.sendMagicLinkEmail(this.loginEmail)
                    .then(() => {

                        this.state = 'emailSent'

                        if (!tryAgain) {

                            this.goStep(2)

                        }

                        const self = this
                        setTimeout(function () {
                            self.startDecrement()
                        }, 3000)


                    })
                    .catch(() => {

                        this.$refs.toast.open()
                        this.state = ''

                    })

            },

            change () {

                this.isErrorEmail = false

                if (this.testEmail()) {
                    this.isValidEmail = true
                } else {
                    this.isValidEmail = false
                }
            },

            startDecrement () {

                this.counter = 30

                this.state = 'trying'

                this.decrement()
            },

            stopDecrement() {
                clearInterval(this.intervalFunction)
            },

            decrement() {

                const self = this
                this.intervalFunction = setInterval(function () {
                    self.counter = self.counter - 1
                }, 1000)
            },

            tryAgain() {

                Tag.clickAmplitude(this, 're_send')

                this.state = 'loading'

                this.sendEmail(true)

            },

            back() {

                if(this.step === 2) {

                    this.step = 1

                } else {

                    this.$router.push({ path: '/'})

                }


            }

        },

        destroyed() {

            this.stopDecrement()
        }

    }
</script>

<style scoped lang="scss">

    .page-container {
        flex-grow: 1;
        background-color: $timberwolf;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: start;
        @media screen and (min-width: $above-tablet-length) {
            justify-content: center;
            min-height: inherit;
        }
    }

    .bloc-white {
        display: flex;
        align-items: center;
        flex-direction: column;
        background-color: $white;
        padding: 25px 16px 0;
        width: 100%;
        flex-grow: 1;
        @media screen and (min-width: $above-tablet-length) {
            width: 501px;
            height: 507px;
            padding: 54px 24px 19px;
            border-radius: 8px;
            box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
            flex-grow: 0;
        }
    }

    .bloc-white-separato {
        justify-content: space-between;
    }

    .bloc-white-child {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .mlp-title {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        letter-spacing: -0.2px;
        text-align: center;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 32px;
            line-height: 1.25;
        }
    }

    .mlp-subtitle {
        font-size: 17px;
        line-height: 1.41;
        text-align: center;
        margin: 4px 0 33px;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 17px;
            line-height: 1.41;
            margin: 9px 0 40px;
        }
    }

    .mlp-input {
        width: 100%;
    }

    .btn-mlp {
        margin: 16px 0;
        @media screen and (min-width: $above-tablet-length) {
            max-width: 275px;
        }
    }

    .mlp-secu {
        font-size: 11px;
        line-height: 1.45;
        text-align: center;
        margin: 18px 0;
    }

    .mlp-mail-send {
        object-fit: contain;
        height: 104px;
        @media screen and (min-width: $above-tablet-length) {
            height: 128px;
        }
    }

    .mlp-blue-title {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        letter-spacing: -0.2px;
        text-align: center;
        color: $aquamarine;
        margin-top: 35px;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 28px;
            line-height: 1.14;
            margin-top: 11px;
        }
    }

    .mlp-bold-email {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        letter-spacing: -0.2px;
        text-align: center;
        color: $midnight;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 20px;
            line-height: 1.2;

        }
    }

    .mlp-text {
        font-size: 12px;
        line-height: 1.33;
        text-align: center;
        color: $grey;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 17px;
            line-height: 1.41;
        }
    }

    .mlp-text-top {
        margin-top: 21px;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 25px;
        }
    }

    .mlp-text-space {
        margin-top: 112px;
    }

    .mlp-link {
        font-size: 17px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.41;
        letter-spacing: normal;
        text-align: center;
        color: $aquamarine;
        cursor: pointer;
    }

    .mlp-trying {
        font-size: 17px;
        font-weight: bold;
        line-height: 1.41;
        color: $grey;
    }

    .mlp-bottom {
        min-height: 32px;
    }

    .mlp-email-sent {
        font-size: 17px;
        font-weight: bold;
        line-height: 1.41;
        color: $green;
    }

    .little-loader {
        height: 17px;
        width: 17px;
    }

    .bottom-bloc-white {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 28px;
        @media screen and (min-width: $above-tablet-length) {
            position: static;
        }
    }

    .airplane {
        width: 130px;
        height: 130px;
    }

</style>
